import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/**
 * 番号引継ぎ可否判定で使う回線引継ぎ情報。
 * 承認番号や有効期限を複数画面で参照するため、API の戻り値をそのまま保持する。
 */
export type LineReuseInfoType = {
  approval_in_num: string;
  approval_out_num: string;
  approval_out_num_limit_date: string;
  line_equip_type: string;
  approval_out_num_limit_over_flg: string;
};

/** 番号引継ぎ情報取得APIの結果を保持する state。 */
export const LineReuseInfoState = atom<LineReuseInfoType>({
  key: 'LineReuseInfoState',
  default: {
    approval_in_num: '',
    approval_out_num: '',
    approval_out_num_limit_date: '',
    line_equip_type: '',
    approval_out_num_limit_over_flg: '',
  },
  effects_UNSTABLE: [persistAtom],
});

export default LineReuseInfoState;
